// src/Pages/DeviceControl.jsx
import React, { useState, useEffect } from 'react';
import ControlForm from '../Components/ControlForm';
import api from '../utils/api';

export default function DeviceControl({ defaultDeviceId = '', currentDeviceData = null }) {
  const [deviceId, setDeviceId] = useState(defaultDeviceId);
  const [controlPayload, setControlPayload] = useState({
    id: defaultDeviceId,
    modechange: 'on',
    modeDirection: '',
    way: '',
    angle: '',
    manual: '',
  });

  const [log, setLog] = useState('');

  // 초기 데이터 세팅
  useEffect(() => {
    if (!currentDeviceData) return;

    const mappedPayload = {
      id: defaultDeviceId,
      modechange: 'on',
      modeDirection: (currentDeviceData.motorDir || '').toLowerCase(),
      way: (currentDeviceData.scanStatus || '').toLowerCase(),
      angle: String(currentDeviceData.scanAngle ?? '').replace('도', '').trim(),
      manual: currentDeviceData.motorFlag === 1 ? 'on' : 'off',
    };

    setDeviceId(defaultDeviceId);
    setControlPayload(mappedPayload);
  }, [defaultDeviceId, currentDeviceData]);

  // 기존 제어 명령 전송
  const handleControlSend = async () => {
    const id = controlPayload.id || deviceId || '(미지정)';
    const confirmMsg =
      `다음 명령을 전송할까요?\n\n` +
      `디바이스 ID: ${id}\n` +
      `수동(manual): ${controlPayload.manual || '(기존값)'}\n` +
      `방향(modeDirection): ${controlPayload.modeDirection || '(기존값)'}\n` +
      `스캔(way): ${controlPayload.way || '(기존값)'}\n` +
      `각도(angle): ${controlPayload.angle || '(기존값)'}\n\n` +
      `계속하시겠어요?`;

    if (!window.confirm(confirmMsg)) {
      setLog('전송 취소');
      return;
    }

    try {
      await api.post('/control', controlPayload);
      setLog('제어 명령 전송 완료');
      window.alert('제어 명령이 전송되었습니다.');
    } catch (error) {
      console.error('control send error:', error);
      setLog('제어 명령 전송 실패');
      window.alert('제어 명령 전송 실패');
    }
  };

  // 🔵 블루투스 모드 전환(RESET) 전송
  const handleBluetoothReset = async () => {
    const id = controlPayload.id || deviceId;

    if (!id) {
      window.alert('디바이스 ID가 없어 /reset 요청을 보낼 수 없습니다.');
      setLog('⚠️ 디바이스 ID 없음으로 /reset 전송 실패');
      return;
    }

    const confirmMsg =
      `블루투스 모드로 전환하기 위해 디바이스를 RESET 할까요?\n\n` +
      `디바이스 ID: ${id}\n\n` +
      `계속하시겠어요?`;

    if (!window.confirm(confirmMsg)) {
      setLog('⏹️ 블루투스 모드 전환(RESET) 취소');
      return;
    }

    try {
      await api.post('/reset', { id, reset: 'reset' });
      setLog('블루투스 모드 전환명령 전송 완료');
      window.alert('블루투스 모드 전환 명령이 전송되었습니다.');
    } catch (error) {
      console.error('bluetooth reset error:', error);
      setLog(' 블루투스 모드 전환(RESET) 전송 실패');
      window.alert('블루투스 모드 전환전송 실패');
    }
  };

  const shownId = controlPayload.id || deviceId || '—';

  return (
    <div className="p-4 max-w-xl mx-auto">
      <h2 className="text-xl font-bold mb-2 flex items-center gap-2">
        <span className="text-xs md:text-sm font-mono px-2 py-0.5 rounded border bg-gray-50">
          {shownId}
        </span>
      </h2>

      {/* ControlForm 은 isAdmin prop 이 없으면 JWT 에서 admin 자동 판별하도록 이미 작성됨 */}
      <ControlForm
        payload={controlPayload}
        onChange={setControlPayload}
        onSend={handleControlSend}
        onBluetoothReset={handleBluetoothReset}   // 👈 여기 추가
      />

      {log && <div className="mt-4 text-sm text-gray-700">🔔 {log}</div>}
    </div>
  );
}
